import React, { Component } from 'react';
import AceEditor from 'react-ace';
import { DSModal } from '@elliemae/ds-legacy-modal';
import DSCodeEditorForm from './DSCodeEditorForm.js';
import 'ace-builds/src-noconflict/mode-javascript.js';
import 'ace-builds/src-noconflict/theme-tomorrow.js';

class DSCodeEditorImpl extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.value,
      errors: [],
    };
    this.reactAceComponent = React.createRef();
  }

  render() {
    const {
      onSave,
      onClose,
      onReject,
      isOpen,
      fileName,
      confirmLabel,
      maxLines,
      minLines,
      modalTitle,
      modalType,
      rejectLabel,
      size,
      style,
      containerProps,
    } = this.props;

    const { value, errors } = this.state;
    const Comp = (AceEditor as any)?.default ?? AceEditor;
    return (
      <DSModal
        centered={false}
        confirmLabel={confirmLabel}
        containerProps={containerProps}
        isOpen={isOpen}
        modalTitle={modalTitle}
        modalType={modalType}
        onClose={() => onClose(value, fileName, errors)}
        onConfirm={() => onSave(value, fileName, errors)}
        onReject={() => onReject(value, fileName, errors)}
        rejectLabel={rejectLabel}
        size={size}
        style={style}
      >
        <DSCodeEditorForm fileName={fileName} reactAceComponent={this.reactAceComponent} />
        <Comp
          ref={this.reactAceComponent}
          editorProps={{ $blockScrolling: true }}
          maxLines={maxLines}
          minLines={minLines}
          mode="javascript"
          name="ace-code-edior"
          onChange={(val) => this.setState({ value: val })}
          onValidate={(annotations) => this.setState({ errors: annotations })}
          theme="tomorrow"
          value={value}
        />
      </DSModal>
    );
  }
}

export default DSCodeEditorImpl;
